import styled from '@emotion/styled';
import { useEffect } from 'react';

import { ToastManager } from '../../../ToastManager';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

import { Throbber } from '../../../components/common/Throbber';

import { notificationSettingsStore } from './NotificationSettingsStore';
import { NotificationSettingsTableOwners } from './NotificationSettingsTableOwners';

export function NotificationSettings() {
  const { notificationSettings } = notificationSettingsStore.use();

  useEffect(() => {
    if (notificationSettings.error != null) {
      ToastManager.handleError(notificationSettings.error);
    }
  }, [notificationSettings.error]);

  if (notificationSettings.isLoading === true) {
    return (
      <S.Root>
        <Throbber size={theme.icon.size_default} />
      </S.Root>
    );
  }

  return (
    <S.Root>
      <NotificationSettingsTableOwners />
    </S.Root>
  );
}

NotificationSettings.pathKey = 'system/timeline';
NotificationSettings.icon = glyph.system.timelineNotifications;
NotificationSettings.backgroundColor = theme.color.system_timeline_notifications;

function S() {}
NotificationSettings.S = S;

S.Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: ${su(4)};

  margin-bottom: ${su(2)};
  flex: 1 0 auto;

  ${Throbber.S.Root} {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;
